<!--
 * @Description: 运营总览主体部分item组件
 * @Author: sunhuihong
 * @Date: 2022-07-13 09:43:52
 * @LastEditTime: 2022-07-13 17:33:29
-->
<template>
  <el-row type="flex" :gutter="30" justify="space-between" style="text-align: left; flex-wrap: wrap; 
    margin-top: 36px;">
    <el-col :span="6" style="padding-left:15px" v-for="(item, index) in messageData" :key="index">
      <div class="view-message-items" :class="index !== 3 && index !== 7 ? 'cursor-style' : ''" 
        @click="handleItem(index)"> 
        <div class="view-message-items-left">
          <img v-if="index==0" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-sign-inst-number.png" alt="">
          <img v-if="index==1" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-online-user-number.png" alt="">
          <img v-if="index==2" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-order-number.png" alt="">
          <img v-if="index==3" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-order-price.png" alt="">
          <img v-if="index==4" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-sign-hosp-number.png" alt="">
          <img v-if="index==5" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-online-attendant-number.png" alt="">
          <img v-if="index==6" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-service-item-number.png" alt="">
          <img v-if="index==7" class="view-message-items-left-img" 
            src="@/assets/overview/icon-overview-custom-unit-price.png" alt="">
        </div>
        <div class="view-message-items-right">
          <span style="font-size: 14px;color: #657180;">
            {{index== 1 ? changeUserNumber(instId) : item.title}}
          </span>
          <div v-if="index == 3 || index == 7" style="font-size: 32px; color: #333333; margin: 5px 0 2px 0; 
            display: flex; align-items: baseline">
            <span v-if="cumulativeData && cumulativeData.orderAmountYuan">
              {{index == 3 ? changeOrderAmountHtml(cumulativeData.orderAmountYuan)[0] + '.' 
                : changeOrderAmountHtml(cumulativeData.avgAmountYuan)[0] + '.' 
              }}
            </span>
            <span style="font-size: 26px;" v-if="cumulativeData && cumulativeData.orderAmountYuan">
              {{index == 3 ? changeOrderAmountHtml(cumulativeData.orderAmountYuan)[1] 
                : changeOrderAmountHtml(cumulativeData.avgAmountYuan)[1]
              }}
            </span>
          </div>
          <div v-else style="display: flex; align-items: center; height: 36px">
            <span style="font-size: 32px; color: #333333; margin: 5px 0 2px  0;">
              {{index == 0 ? (cumulativeData.signingInstitutionCount || '0') 
                : index == 1 ? (cumulativeData.userCount || '0')
                : index == 2 ? (cumulativeData.orderCount || '0') 
                : index == 4 ? (cumulativeData.singingHospitalCount || '0') 
                : index == 5 ? (cumulativeData.attendantCount || '0') 
                : index == 6 ? (cumulativeData.hserviceCount || '0') 
                : ''
              }}
            </span>
            <span v-if="index == 2" class="repurchase-style">
              {{'复购' + (cumulativeData.orderRepurchaseCount || '0')}}
            </span>
          </div>
          <div v-show="index == 2 || index == 3 || index == 6" style="font-size: 14px; color: #657180;">
            <span>
              {{index == 2 ? (cumulativeData.orderCumulativeCount ? ('累计&nbsp;&nbsp;'+ cumulativeData.orderCumulativeCount) : '累计&nbsp;&nbsp;0') 
                : index == 3 ?(cumulativeData.orderAmountCumulativeYuan ? ('累计&nbsp;&nbsp;' + cumulativeData.orderAmountCumulativeYuan) : '累计&nbsp;&nbsp;0') 
                : index == 6 ? (cumulativeData.hserviceCumulativeCount ? ('累计&nbsp;&nbsp;' + cumulativeData.hserviceCumulativeCount) : '累计&nbsp;&nbsp;0')
                : ''
              }}
            </span>
            <span style="margin-left: 10px;" v-if="index == 2">
              {{'复购&nbsp;&nbsp;&nbsp;' + (cumulativeData.orderCumulativeRepurchaseCount || '0')}}
            </span>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'MessageItem',
  props: ["cumulativeData", "instId"],

  data() {
    return {
      messageData: [
        {title: '签约机构数'},
        {title: '用户数'},
        {title: '订单数'},
        {title: '订单金额(元)'},
        {title: '签约医院数'},
        {title: '护工数'},
        {title: '服务项目数'},
        {title: '客单价(元)'},
      ] 
    }
  },

  methods: {
    handleItem(index) {
      this.$emit("handle-message-item", index);
    },

    changeOrderAmountHtml(data) {
      let isNumber = isNaN(Number(data));
      if (!isNumber) {
        return data.split(".");
      } else {
        return [data];
      }   
    },

    //不查机构时，名称为“用户数”，查机构时，名称为“ 下单用户数”。
    changeUserNumber(instId) {
      if (instId == null || instId == '') {
        return '用户数';
      } else {
        return '下单用户数';
      } 
    }   
  },
}
</script>

<style scoped>
.view-message-items {
  border-radius: 6px;
  border: 1px solid #D7DDE5;
  height: 120px;
  display: flex;
  padding-left: 31px;
  margin-bottom: 15px;
}

.view-message-items-left {
  width: 43px;
  height: 100%;
  display: flex;
  align-items: center;
}

.view-message-items-left-img {
  width: 43px;
  height: 43px;
}

.view-message-items-right {
  height: 100%;
  padding: 18px 0 14px 0;
  margin-left: 24px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.cursor-style {
  cursor: pointer;
}

.repurchase-style {
  border-radius: 3px;
  border: 1px solid #FF4D18;
  font-size: 12px;
  color: #FF4D18;
  padding: 0 4px;
  margin: 0 0 0 10px;
}
</style>





// WEBPACK FOOTER //
// src/components/overview/components/MessageItem.vue